import { render, staticRenderFns } from "./ProdutoPesquisaAvancadaModal.vue?vue&type=template&id=0f85e4a7&scoped=true"
import script from "./ProdutoPesquisaAvancadaModal.vue?vue&type=script&lang=js"
export * from "./ProdutoPesquisaAvancadaModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutoPesquisaAvancadaModal.vue?vue&type=style&index=0&id=0f85e4a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f85e4a7",
  null
  
)

export default component.exports